const globalConfig = global.wizecareHelpers.globalConfigGetViaUrlSync(process.env.REACT_APP_GLOBAL_CONFIG_URL);
const globalConfigTools = new global.GlobalConfigTools(globalConfig);

// For having access from a console in a browser
global.globalConfigTools = globalConfigTools;

globalConfigTools.defineServiceDiscovery(process.env.REACT_APP_CLOUD_ENV);

if (!globalConfigTools.serviceDiscovery()) {
  throw new Error(`Can not proceed without defining the current environment.`);
}

export const AUTH_ABSENT_TOKEN_STUB = 'notLoggedIn'; // It must be the same value as the backend constant BearerTokenService::FRONTEND_DOES_NOT_HAVE_TOKEN.

export const APPS = {
  WEB: 3, IOS: 2, ANDROID: 1,
};
export const APPS_URL = globalConfigTools.serviceDiscovery('app');

export const WEBSITE_URL = globalConfigTools.serviceDiscovery('site');

export const LOG_IT_ENDPOINT = `${globalConfigTools.serviceDiscovery('frontLogger')}/add`

export const TOLGEE_CDN_BASE =
  (typeof globalConfigTools?.getTolgeeLoginBaseUrl === 'function' && globalConfigTools.getTolgeeLoginBaseUrl()) ||
  null;

export const DISPATCHER_ENDPOINT = () => {
  const isProdQA = (document.domain.indexOf("qa-ajrpwavu4a") > -1)
  if (isProdQA) {
    return "https://qa-api.wizecare.com/vt/api/dispatcher.php"
  }
  const backend = globalConfigTools.serviceDiscovery('backend');
  return `${(backend || "").replace(/\/$/, "")}/vt/api/dispatcher.php`;
}

export const PUBLIC_ASSETS_URL = globalConfigTools.serviceDiscovery('storages')['public_assets'];

export const PHONE_PREFERRED_COUNTRIES = globalConfigTools.serviceDiscovery().phonePreferredCountries;
export const PHONE_ONLY_COUNTRIES = globalConfigTools.serviceDiscovery().phoneOnlyCountries;
export const DEFAULT_COUNTRY_CODE = globalConfigTools.serviceDiscovery().defaultCode;

export const FIREBASE_CONFIG = () => {
  return globalConfigTools.serviceDiscovery('firebase');
}

export const PROVIDERS_TYPE = {
  GOOGLE: "google", APPLE: "apple", FACEBOOK: "facebook", SAML: "saml", OTP: "otp",
};

export const SAML_PROVIDER_MAP = {
  "clalit.org.il": "saml.clalit",
  "leumit.co.il": "saml.leumit",
};

export const ALLOWED_SAML_TYPES = ["saml.clalit", "saml.leumit"];

export const API = {
  UPDATE_ACCOUNT_DETAILS: "accounts/update-account-details",
  RESET_PASSWORD: "accounts/reset-password",
  LOGIN_HELPER: "accounts/login-helper",
  RESEND_OTL: "accounts/resend-otl",
};

/** v2 REST API — direct HTTP to serviceDiscovery('api'), NOT the PHP dispatcher. */
export const V2_API_ACCEPT = "api/version:v2";

export const V2_PATHS = {
  THERAPISTS_ME: "/v2/therapists/me",
  THERAPISTS_FOR_REGISTRATION: "/v2/therapists/account/for-registration",
  THERAPISTS_SUB_ACCOUNT: "/v2/therapists/my/sub-account",
  THERAPIST_PROFESSIONS: "/v2/therapists/account/my/professions",
  ACCOUNTS_MY_TYPE: "/v2/accounts/my/type",
  ACCOUNTS_UPDATE_PASSWORD: "/v2/accounts/update-password",
  THERAPISTS_ACCEPT_TERMS_AND_CONDITIONS: "/v2/therapists/account/accept-terms-and-conditions",
  ACCOUNTS_UPDATE_PERSONAL_DETAILS: "/v2/accounts/update-personal-details",
  ACCOUNTS_EMAIL_OR_PHONE: "/v2/accounts/my/email-or-phone",
  ACCOUNTS_PROFILE_PHOTO: "/v2/accounts/my/photo",
  ACCOUNTS_CUSTOM_TOKEN_BY_OTL: "/v2/accounts/custom-token-by-otl/",
  ACCOUNTS_CUSTOM_TOKEN_BY_RESET_CODE: "/v2/accounts/custom-token-by-reset-code",
  ACCOUNTS_CUSTOM_TOKEN: "/v2/accounts/custom-token",
  USERS_RESET_PASSWORD_REQUEST: "/v2/users/reset-password-request",
  USERS_SEND_ONE_TIME_LINK: "/v2/users/send-one-time-link",
  PATIENTS_RESET_PASSWORD: "/v2/patients/reset-password",
};

export const CLINICIAN_TERMS_VERSION = "clinician-terms-of-use-v1";

export const THERAPIST_ROLES = {
  ROLE_CLINIC_OWNER: "ROLE_CLINIC_OWNER",
  ROLE_SUPERUSER: "ROLE_SUPERUSER",
  ROLE_CLINIC_ADMIN: "ROLE_CLINIC_ADMIN",
  ROLE_CLINIC_BASE: "ROLE_CLINIC_BASE",
};

export const CLINICIAN_ROLES = {
  OWNER: "owner",
  ADMIN: "admin",
  BASE: "base",
};

export const API_RES_CODE = {
  SUCCESS: 100,
  UNAUTHORIZED: 403,
  ERROR_EXPIRE_CODE: 110,
  ERROR_USER_ALREADY_ONBOARDED: 154,
  PASSWORD_TOO_WEAK: 125,
  ERROR_LOGIN_ACCOUNT_FAILURE: 114,
  LOGIN_FAIL_BAD_CREDENTIALS: 115,
  BAD_RESET_CODE: 124,
};

export const URL_PARAMS = {
  HOST: 'host', //the host who called this app (WordPress, instant VC, ios ect)
  OTL: 'OTL', //one time login code
  REGISTRATION_CODE: 'registrationCode', //clinician registration code
  RESET_CODE: 'resetCode', //reset password code
  FORGOT_PASSWORD: 'forgot', //for routing
  CUSTOM_TOKEN: 'customToken', //for onboarding
  APPTYPE: 'apptype', //the type of app (clinician, patient)
  WIZE_EXT_ADDITIONAL_APPS: 'wize_ext_additional_apps',
};

export const WIZE_EXT_APPS = {
  CLINICIAN: 'clinician_app',
  PATIENT: 'patient_app',
};
export const MOBILE_HOSTS = {
  IOS: 'ios', ANDROID: 'android',
};

export const USER_TYPES = {
  CLINICIAN: 'clinician',
  THERAPIST: 'therapist',
  PATIENT: 'patient'
};

export const SAML_PROVIDER_CLALIT = 'clalit';
export const SAML_PROVIDER_LEUMIT = 'leumit';

export const LOCAL_STORAGE_KEYS = {
  LAST_SAML_PROVIDER: 'lastSamlProvider'
};

export const LOG_SEVERITIES = {
  DEBUG: 100,
  INFO: 200,
  NOTICE: 300,
  WARNING: 400,
  ERROR: 500,
  CRITICAL: 600,
  ALERT: 700,
  EMERGENCY: 800,
};
export const MESSAGES_TYPES = {
  LOGIN_SUCCESS: 'loginSuccess', //good end of process
  ONBOARDING_END_UNSUCCESSFULLY: 'onboardingEndUnsuccessfully', //bad end of process
  PROVIDER_LOGIN: 'providerLogin', //needed for handling native back arrow on mobile
  PROVIDER_LOGIN_END: 'providerLoginEnded',
  HIDE_PRELOADER: 'hidePreloader', //app is ready for user input
  SHOW_PRELOADER: 'showPreloader',
  BACK_HOME: 'backHome', //flow has been reset
  CLOSE: 'close', //close the login app (web close button)
  GO_ONBOARDING: 'goOnboarding',
  LANGUAGE_CHANGE: 'languageChange',
  NATIVE_AUTH_WITH_GOOGLE: 'nativeAuthWithGoogle',
  NATIVE_AUTH_WITH_APPLE: 'nativeAuthWithApple',
  NATIVE_AUTH_WITH_SAML: 'nativeAuthWithSaml',
  CLOUD_ENV_PROD: 'prod',
  CLOUD_ENV_PROD_USA: 'prod_usa'
}

export const OTP_EVENTS = {
  SMS_SEND_SUCCESS: "SMS_SEND_SUCCESS",
  SMS_SEND_ERROR: "SMS_SEND_ERROR",
  SMS_VERIFY_SUCCESS: "SMS_VERIFY_SUCCESS",
  SMS_VERIFY_ERROR: "SMS_VERIFY_ERROR",
  SMS_RESEND_SUCCESS: "SMS_RESEND_SUCCESS",
  SMS_RESEND_ERROR: "SMS_RESEND_ERROR",
  OTL_SEND_SUCCESS: "OTL_SEND_SUCCESS",
  OTL_SEND_ERROR: "OTL_SEND_ERROR",
  OTL_RESEND_SUCCESS: "OTL_RESEND_SUCCESS",
  OTL_RESEND_ERROR: "OTL_RESEND_ERROR",
  OTL_SCORE_ERROR: "OTL_SCORE_ERROR",
};

export const REDIRECT_TYPES = {
  HOME: 'home',
  FORGOT_PASSWORD: 'forgotPassword',
  RESET_PASSWORD: 'resetPassword',
  ONBOARDING: 'onboarding',
  IOS_CLINICIAN: 'iosClinician',
}

export const WHATSAPP_CONTACT_URL = "https://wa.me/972559979579";

export const RESPONDIO_CHANNEL_ID = globalConfigTools.getRespondioLoginChannelId();

export const DEFAULT_HOSTS = {
  WEBSITE: 'website',
  ANDROID: 'android',
};

export function changeRegion(region) {
  const serviceDiscoveryObject = global.globalConfigTools.globalConfig.environment[region].serviceDiscovery;
  const urlParams = new URLSearchParams(window.location.search);
    if (window.self !== window.top) {
        window.parent.location.href = serviceDiscoveryObject.app + '/?host=' + (urlParams.get('host') ?? DEFAULT_HOSTS.WEBSITE);
    } else {
        window.location.href = serviceDiscoveryObject.login + '/?host=' + (urlParams.get('host') ?? DEFAULT_HOSTS.ANDROID);
    }
}



